module.exports = __webpack_public_path__ + "hu.fd87f88e0a1362178aba.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/hu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/hu.svg
// module chunks = styles